export default "__VITE_ASSET__BipGttZ8__"